const getMockData = (initialState) => {
    initialState.metrics = [
        {
            title: "Negotiations",
            value: "23",
            change: "+4",
            isUp: true,
        },
        {
            title: "YTD Savings",
            value: "$34M",
            change: "+12",
            isUp: true,
        },
        {
            title: "Risk Score",
            value: "82/100",
            change: "+3",
            isUp: true,
        },
        {
            title: "Renewal Rate",
            value: "94%",
            change: "+2",
            isUp: true,
        },
        {
            title: "Cycle (Days)",
            value: "42",
            change: "-5",
            isUp: false,
        },
        {
            title: "Compliance",
            value: "98%",
            change: "+1",
            isUp: true,
        },
    ];

    initialState.projects = [
        {
            title: "Global Cloud Provider Consolidation",
            status: "In Progress",
            completion: 0.8,
            isPositive: true,
        },
        {
            title: "SaaS Vendor Security Compliance",
            status: "Critical Review",
            completion: 0.6,
            isPositive: false,
        },
        {
            title: "Data Center Hardware Refresh",
            status: "Planning",
            completion: 0.9,
            isPositive: true,
        },
        {
            title: "Microsoft EA Renewal 2025",
            status: "On Track",
            completion: 0.95,
            isPositive: true,
        },
        {
            title: "Real Estate Plan 5",
            status: "Negotiation",
            completion: 0.4,
            isPositive: false,
        },
        {
            title: "Salesforce CRM Upgrade",
            status: "In Progress",
            completion: 0.75,
            isPositive: true,
        },
    ];

    initialState.projects = [
        {
            title: "Global Cloud Provider Consolidation",
            counterparty: "Acme Corp",
            effectiveDate: "2023-01-01",
            region: "North America",
            status: "In Progress",
            completion: 0.8,
            isPositive: true,
        },
        {
            title: "SaaS Vendor Security Compliance",
            counterparty: "TechCorp",
            effectiveDate: "2023-02-15",
            region: "North America",
            status: "Critical Review",
            completion: 0.6,
            isPositive: false,
        },
        {
            title: "Data Center Hardware Refresh",
            counterparty: "Data Solutions Inc.",
            effectiveDate: "2023-05-10",
            region: "North America",
            status: "Planning",
            completion: 0.9,
            isPositive: true,
        },
        {
            title: "Microsoft EA Renewal 2025",
            counterparty: "Microsoft",
            effectiveDate: "2023-07-01",
            region: "North America",
            status: "On Track",
            completion: 0.95,
            isPositive: true,
        },
        {
            title: "Real Estate Plan 5",
            counterparty: "McDonald's",
            effectiveDate: "2023-09-15",
            region: "North America",
            status: "Negotiation",
            completion: 0.4,
            isPositive: false,
        },
        {
            title: "Salesforce CRM Upgrade",
            counterparty: "Salesforce",
            effectiveDate: "2023-09-15",
            region: "North America",
            status: "In Progress",
            completion: 0.75,
            isPositive: true,
        },
        {
            title: "AI Integration for Customer Support",
            counterparty: "Zendesk",
            effectiveDate: "2023-10-01",
            region: "North America",
            status: "On Track",
            completion: 0.7,
            isPositive: true,
        },
        {
            title: "Data Privacy Regulation Update",
            counterparty: "Legal Advisors LLP",
            effectiveDate: "2023-11-01",
            region: "Europe",
            status: "In Progress",
            completion: 0.65,
            isPositive: false,
        },
        {
            title: "Cloud Cost Optimization Initiative",
            counterparty: "OptimizeCloud",
            effectiveDate: "2023-12-15",
            region: "Asia",
            status: "Planning",
            completion: 0.2,
            isPositive: true,
        },
        {
            title: "Global Employee Training Program",
            counterparty: "SkillShare Pro",
            effectiveDate: "2024-01-10",
            region: "Global",
            status: "On Hold",
            completion: 0.5,
            isPositive: false,
        },
        {
            title: "New Vendor Onboarding Process",
            counterparty: "ProcureTech",
            effectiveDate: "2024-02-01",
            region: "North America",
            status: "Completed",
            completion: 1.0,
            isPositive: true,
        },
        {
            title: "AI-Powered Analytics Rollout",
            counterparty: "BigData Solutions",
            effectiveDate: "2024-02-15",
            region: "Europe",
            status: "In Progress",
            completion: 0.8,
            isPositive: true,
        },
        {
            title: "Third-Party Risk Assessment",
            counterparty: "SecureIT",
            effectiveDate: "2024-03-01",
            region: "North America",
            status: "Critical Review",
            completion: 0.6,
            isPositive: false,
        },
        {
            title: "Cybersecurity Incident Response Upgrade",
            counterparty: "CyberSafe Inc.",
            effectiveDate: "2024-03-20",
            region: "North America",
            status: "On Track",
            completion: 0.75,
            isPositive: true,
        },
        {
            title: "Hybrid Work Enablement Initiative",
            counterparty: "RemoteTech",
            effectiveDate: "2024-04-01",
            region: "Global",
            status: "In Progress",
            completion: 0.4,
            isPositive: true,
        },
    ];

    initialState.notifications = [
        // Flags
        {
            type: "flag",
            title: "Oracle ULA True-up Due",
            dueDate: "2024-12-15",
            priority: "Critical",
        },
        {
            type: "flag",
            title: "AWS Reserved Instance Expiration",
            dueDate: "2024-12-30",
            priority: "High",
        },
        {
            type: "flag",
            title: "VMware ELA Compliance Review",
            dueDate: "2025-01-15",
            priority: "Medium",
        },
        // Alerts
        {
            type: "alert",
            category: "Contract",
            message:
                "Salesforce subscription renews in 60 days",
            dueDate: "2024-12-01",
        },
        {
            type: "alert",
            category: "Compliance",
            message:
                "15 vendors: security assessment incomplete",
            dueDate: "2024-12-01",
        },
        {
            type: "alert",
            category: "Budget",
            message:
                "Q4 IT Spend tracking 7% above forecast",
            dueDate: "2024-12-01",
        },
        {
            type: "alert",
            category: "Operations",
            message:
                "Data center power consumption 12% above",
            dueDate: "2024-12-01",
        },
    ];
};

export default getMockData;
